function toggleModal() {
  document.querySelector('.coop-c-modal')
    .classList.toggle('coop-c-modal__hidden');
}

window.addEventListener('DOMContentLoaded', function(event) {

  var bookButton = document.querySelector("#coop-c-modal__redirect-booking-button");
  if(bookButton) {
    bookButton.addEventListener("click", function (event) {
      event.preventDefault();
      toggleModal();
    });
  }

  var closeBar =  document.querySelector(".coop-c-modal__close-bar span");
  if(closeBar) {
    closeBar.addEventListener("click", toggleModal);
  }

  var cancelButton = document.querySelector("#coop-c-modal__cancel-button");
  if(cancelButton) {
    cancelButton.addEventListener("click", function (event) {
      event.preventDefault();
      toggleModal();
    });
  } 

  var bookingButton = document.querySelector("#quick-bar__booking-button");
  if(bookingButton) {
    bookingButton.addEventListener("click", function (event) {
      event.preventDefault();
      toggleModal();
    });
  } 

  var bookingButtonDesktop = document.querySelector("#quick-bar__booking-button-desktop");
  if(bookingButtonDesktop) {
    bookingButtonDesktop.addEventListener("click", function (event) {
      event.preventDefault();
      toggleModal();
    });
  } 

  var redirectButton = document.querySelector("#coop-c-modal__redirect-button");
  if(redirectButton) {
    redirectButton.addEventListener("click", function () {
      toggleModal();
    });
  } 

});